<template>
  <div id="contact">
    <div class="parallax">
      <div id="addressBox">
        <h1>Wirral</h1>
        <hr />
        <h2>Pandle House, 70 Grange Road East</h2>
        <h2>CH41 5FE</h2>
        <h3>United Kingdom</h3>
        <br />
        <!-- <a class="simpleIcon" href="https://goo.gl/maps/BGNEj498W1Q2"> -->
        <v-icon large color="white">location_on</v-icon>
        <!-- </a> -->
        <br />
        <br />
        <br />

        <h3>
          <a class="simpleIcon" href="mailto:enquiries@beral.biz">
            <v-icon small color="white">email</v-icon>
            enquiry@rethymos.com
          </a>
        </h3>
      </div>
    </div>
  </div>

  <!-- <div id="socialIcons">
                <i class="fa fa-instagram" style="font-size:48px"></i>
                <i class="fa fa-linkedin-square" style="font-size:48px"></i>
                <i class="fa fa-facebook-square" style="font-size:48px"></i>
            </div> -->
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Crimson+Text");
.simpleIcon {
  text-decoration: none;
  color: white;
}

#contact {
  margin-top: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

#addressBox {
  background: black;
  content: center;
  padding: 20px;
  border-radius: 4px;
  opacity: 0.95;
  width: auto;
  color: white;
  /* font-family: 'Crimson Text', sans-serif; */
}

.parallax {
  margin: 0%;
  background-image: url("/charter.jpg");
  height: 500px;
  width: 100%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  margin-left: 10px;
}
</style>